import { render, staticRenderFns } from "./SlideShowSection.vue?vue&type=template&id=ac08bf0c&scoped=true&"
import script from "./SlideShowSection.vue?vue&type=script&lang=js&"
export * from "./SlideShowSection.vue?vue&type=script&lang=js&"
import style0 from "./SlideShowSection.vue?vue&type=style&index=0&id=ac08bf0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac08bf0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VSheet})
